import request from '@/utils/request';

// 获取部门排行榜
export function getDepartmentRankingLists(data) {
    return request({
        url: '/wap/ranking/get_department_ranking_lists',
        method: 'post',
        data: data,
        headers: {
            needToken: true
        }
    });
}
// 获取镇街排行榜
export function getZhenjieRankingLists(data) {
    return request({
        url: '/wap/ranking/get_zhenjie_ranking_lists',
        method: 'post',
        data: data,
        headers: {
            needToken: true
        }
    });
}
// 会员排行榜
export function getMemberRankingLists(data) {
    return request({
        url: '/wap/ranking/get_member_ranking_lists',
        method: 'post',
        data: data,
        headers: {
            needToken: true
        }
    });
}

// 获取个人每日任务完成情况
export function get_member_day_task_info(data) {
    return request({
        url: '/wap/ranking/get_member_day_task_info',
        method: 'post',
        data: data,
        headers: {
            needToken: true
        }
    });
}

// 获取个人每日任务完成情况
export function get_dept_task_info(data) {
    return request({
        url: '/wap/ranking/get_dept_task_info',
        method: 'post',
        data: data,
        headers: {
            needToken: true
        }
    });
}
// 获取部门人员完成情况 V2
export function get_dept_task_info_two(data) {
    return request({
        url: '/wap/ranking/get_dept_task_info_two',
        method: 'post',
        data: data,
        headers: {
            needToken: true
        }
    });
}